import { Project } from '@/shared/config/projects';
import { projectAxios } from '@/shared/core/axios';

import type { LoginFormDTO, LoginFormResponseDTO } from './dto/auth.dto';

/**
 * Запрос на авторизацию
 *
 * @param data - Данные для авторизации LoginFormDTO
 * @returns Ответ с данными юзера LoginResponseDTO
 */
export const login = async (
  project: Project,
  data: LoginFormDTO,
): Promise<LoginFormResponseDTO> => {
  return (await projectAxios[project].post('/auth/login', data)).data;
};
